import React, { useState } from 'react';
import { DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import useTranslation from 'Hooks/useTranslation';
import { colors } from 'Constants/Colors';
import MultiSelectInput from '../MultiSelectInput';

export default function EnrollUsersModal({ cancel = () => {}, accept = () => {}, title = '', users = null }) {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const { t2 } = useTranslation('EditCourse');

  const handleUserSelect = array => {
    setSelectedUsers([...array]);
  };

  return (
    <div className="col">
      <DialogTitle
        style={{
          fontWeight: 'bold',
          color: colors.BLACK,
          fontFamily: 'quicksand',
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <MultiSelectInput
          name="users"
          data={users}
          selected={selectedUsers || []}
          onChange={handleUserSelect}
          placeHolderText={t2('Users')}
        />
      </DialogContent>
      <DialogActions>
        <Button style={{ fontFamily: 'quicksand' }} color="success" variant="outlined" onClick={cancel}>
          {t2('Cancel')}
        </Button>
        <Button
          style={{ fontFamily: 'quicksand' }}
          color="success"
          onClick={async () => {
            accept(selectedUsers);
            setSelectedUsers([]);
          }}
          variant="contained"
        >
          {t2('Enroll')}
        </Button>
      </DialogActions>
    </div>
  );
}
